import { accessTokens } from 'api/accessTokenMgmt'
import React from 'react'
import { useBsvExchangeRate } from 'api/useBsvExchangeRate'
import InitialsAvatar from 'components/users/InitialsAvatar'
import { RadioArtist, formatEarned } from './radioArtistsModel'
import styles from './radio-artists.module.scss'

// The app's query client never refetches by default; rankings move with every
// play and upvalue, so these refresh when stale on mount.
export const ARTISTS_STALE_MS = 30 * 1000
export const ARTISTS_GC_MS = 5 * 60 * 1000

export const getJson = async (url: string) => {
    // The viewer's tokens: Top New and My Music depend on knowing who's asking.
    const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', ...accessTokens() },
    })
    if (!response.ok) throw new Error(`Request failed: ${response.status}`)
    return response.json()
}

// Earned amounts in money colors: green for dollars, orange for sats.
export function ArtistMoney({ sats }: { sats: number }) {
    const exchangeRate = useBsvExchangeRate()
    const label = formatEarned(sats, exchangeRate)
    return <span className={label.startsWith('$') ? styles.usd : styles.sats}>{label}</span>
}

export function ArtistAvatar({ artist }: { artist: RadioArtist }) {
    const url = artist.avatar_urls?.small || artist.avatar_urls?.original
    return (
        <span className={styles.avatar} aria-hidden="true">
            {url ? <img src={url} alt="" /> : <InitialsAvatar user={artist} />}
        </span>
    )
}
